<template>
    <div>
        <h1>{{ $t("admin.adminNotificationList.header") }}</h1>
        <router-link to="/admin/notificationCreate">{{ $t("admin.adminNotificationList.link.create") }}</router-link><br/>
        <form id="search" @submit="notificationSearch">
            <label for="searchTerm">{{ $t("admin.adminNotificationList.search") }}: </label>
            <input id="searchTerm" name="searchTerm" v-model="searchTerm"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminNotificationList.button.search')">
        </form>

        <table v-if="notificationList" class="datatable">
            <caption class="caption">Notification list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminNotificationList.table.subject") }}</th>
                <th scope="col">{{ $t("admin.adminNotificationList.table.date") }}</th>
                <th scope="col">{{ $t("admin.adminNotificationList.table.enabled") }}</th>
            </tr>
            <tr v-for="(notification, index) in notificationList" v-bind:key="index">
                <td><router-link :to="'/admin/notificationView/' + notification.id">{{ notification.subject }}</router-link></td>
                <td>{{ notification.date }}</td>
                <td>{{ notification.enabled ? $t("common.yes") : $t("common.no") }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminNotificationList',
        data: function() {
            return { notificationList: [], searchTerm: "" };
        },
        created: function() {
            this.notificationSearch(null);
        },
        methods: {
            notificationSearch: function (event) {
                adminService.notificationSearch(this.searchTerm).then((data) => {
                    this.notificationList = data;
                }).catch((err) => {
                    console.error('Unable to get notification: ', err)
                })
                if (event) {
                    event.preventDefault()
                }
            }
        }
    }
</script>
